export default __webpack_public_path__ + "static/media/bonus.3b997196.webp";